/**
 * readableDate
 *
 * @param {string} date
 * @param {string} iso
 * @returns {string} example: 26.09.2023
 */
export function readableDate (date, iso = 'de-DE') {
  return new Date(date).toLocaleDateString(iso, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

/**
 * isAvailableNow
 *
 * @param {object} dataset
 * @param {string} fieldFrom
 * @param {string} fieldTo
 * @returns {boolean}
 */
export function isAvailableNow (
  dataset,
  fieldFrom = 'availableFrom',
  fieldTo = 'availableTo'
) {
  const now = new Date()
  const from = dataset[fieldFrom] ? new Date(dataset[fieldFrom]) : null
  const to = dataset[fieldTo] ? new Date(dataset[fieldTo]) : null

  return (!from || from <= now) && (!to || to >= now)
}
